import { render, staticRenderFns } from "./EditPrize.vue?vue&type=template&id=04d78adb&"
import script from "./EditPrize.vue?vue&type=script&lang=js&"
export * from "./EditPrize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports